import { proceduresConditionsSlice } from "./proceduresConditionsSlice";
import * as actions from "./proceduresConditionsActions";
import * as selectors from "./proceduresConditionsSelectors";

export { actions };
export { selectors };
export default proceduresConditionsSlice.reducer;
